const GA_MEASUREMENT_ID = 'G-T0JGTY35S8';
const GA_SCRIPT_ID = 'cnk-ga4-script';

export const PRIVATE_ANALYTICS_PREFIXES = [
  '/admin',
  '/vendeur',
  '/livreur',
  '/agent-pr',
  '/affiliate/dashboard',
  '/account',
];

export const shouldTrackPath = (pathname = '') => (
  !PRIVATE_ANALYTICS_PREFIXES.some((prefix) => String(pathname || '').startsWith(prefix))
);

export const installGoogleAnalytics = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  const existingScript = document.getElementById(GA_SCRIPT_ID)
    || document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`);

  if (!existingScript) {
    const script = document.createElement('script');
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  if (!window.__cnkGa4Configured) {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: false,
    });
    window.__cnkGa4Configured = true;
  }
};

export const trackPageView = (path) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: `${window.location.origin}${path}`,
    page_path: path,
    send_to: GA_MEASUREMENT_ID,
  });
};
